module.exports = __webpack_public_path__ + "622bf373fa3643b5bc6dc8cd0e6a662a.jpg";